import { useNavigate } from 'react-router-dom';
import { ReportToTfLTemplate } from '@templates';
import { RoutesList } from '@abvehicles/routes/Routes';

export const ReportToTflPage = () => {
  const navigate = useNavigate();
  const formTitle = 'You cannot report abandoned vehicle from this location';

  const buttonPrevious = {
    label: 'Previous',
    onClick: () => {
      navigate(RoutesList.ISSUE_LOCATION);
    },
  };

  return (
    <ReportToTfLTemplate
      formTitle={formTitle}
      buttonPrevious={buttonPrevious}
    />
  );
};
